var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquarespace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18180_90903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 0H6C2.68629 0 0 2.68629 0 6V34C0 37.3137 2.68629 40 6 40H34C37.3137 40 40 37.3137 40 34V6C40 2.68629 37.3137 0 34 0Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18180_90903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4855 20.1639L20.0651 14.5902C20.442 14.2152 20.9521 14.0047 21.4838 14.0047C22.0154 14.0047 22.5255 14.2152 22.9024 14.5902L23.3361 15.0238L24.2053 14.1546L23.7717 13.719C23.1636 13.1122 22.3398 12.7715 21.4808 12.7715C20.6218 12.7715 19.798 13.1122 19.1899 13.719L13.6143 19.2946L14.4855 20.1639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.934 16.4248L21.0648 15.5556L15.4832 21.1372C15.1061 21.514 14.5949 21.7256 14.0618 21.7254C13.5288 21.7252 13.0177 21.5133 12.6409 21.1362C12.2641 20.7592 12.0525 20.2479 12.0527 19.7149C12.0529 19.1819 12.2648 18.6707 12.6419 18.294L17.4572 13.4786L16.588 12.6094L11.7727 17.4247C11.4661 17.7242 11.222 18.0815 11.0545 18.4759C10.8871 18.8703 10.7995 19.2941 10.7969 19.7226C10.7944 20.1511 10.8769 20.5759 11.0396 20.9723C11.2024 21.3687 11.4422 21.7289 11.7451 22.032C12.0481 22.3351 12.4082 22.575 12.8045 22.738C13.2008 22.9009 13.6256 22.9836 14.0541 22.9812C14.4826 22.9788 14.9064 22.8914 15.3009 22.7241C15.6954 22.5568 16.0528 22.3129 16.3524 22.0065L21.934 16.4248ZM27.4899 17.4247C26.8816 16.8185 26.0578 16.4781 25.199 16.4781C24.3402 16.4781 23.5165 16.8185 22.9082 17.4247L17.3266 23.0064L18.1958 23.8756L23.7774 18.294C24.0586 18.0133 24.4166 17.8224 24.8063 17.7451C25.1959 17.6679 25.5997 17.7078 25.9667 17.8599C26.3336 18.0121 26.6473 18.2695 26.868 18.5998C27.0887 18.9301 27.2066 19.3184 27.2068 19.7156C27.2078 19.9802 27.1557 20.2424 27.0537 20.4866C26.9517 20.7307 26.8018 20.952 26.6128 21.1372L21.8033 25.9526L22.6745 26.8218L27.4899 22.0065C28.0966 21.3984 28.4374 20.5746 28.4374 19.7156C28.4374 18.8566 28.0966 18.0328 27.4899 17.4247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7766 19.2676L19.1949 24.8472C18.8175 25.2235 18.3063 25.4348 17.7733 25.4348C17.2403 25.4348 16.7291 25.2235 16.3517 24.8472L15.918 24.4116L15.0488 25.2808L15.4824 25.7164C16.0907 26.3227 16.9145 26.6631 17.7733 26.6631C18.6321 26.6631 19.4559 26.3227 20.0642 25.7164L25.6458 20.1328L24.7766 19.2676Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18180_90903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18180_90903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.82,
    height: 14.256,
    fill: "white",
    transform: "translate(10.8262 12.6074)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarespace);
export default __webpack_public_path__ + "static/media/Squarespace.a6d4f912ff113c76115a97b70c74971c.svg";
export { ForwardRef as ReactComponent };